module.exports = __webpack_public_path__ + "img/beaver3.b207a971.png";